import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["playlistId", "period"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import i18n from 'i18n';
import { checkIsNumber } from 'types/utils';
import api from 'utils/api';
import config from 'utils/config';
import isAdmin from 'utils/session/isAdmin';
import { formatPeriod } from 'actions/utils';
import { fetchContentComments } from 'actions/assets/useFetchAssetAnalytics';
import { playlistQueryKeys } from '.';
function fetchPlaylistOpens(_x, _x2) {
  return _fetchPlaylistOpens.apply(this, arguments);
}
function _fetchPlaylistOpens() {
  _fetchPlaylistOpens = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(playlistId, period) {
    var created_time, q, resp;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          created_time = formatPeriod(period);
          q = {
            fields: {
              openCount: 'COUNT(DISTINCT id)'
            },
            filter: {
              action: 'open',
              category: 'collection',
              created_time: created_time,
              ref_id: playlistId
            }
          };
          _context2.next = 4;
          return api('get', '/api/query/events', q);
        case 4:
          resp = _context2.sent;
          return _context2.abrupt("return", resp.items[0].openCount || 0);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchPlaylistOpens.apply(this, arguments);
}
function fetchPlaylistSaves(_x3, _x4) {
  return _fetchPlaylistSaves.apply(this, arguments);
}
function _fetchPlaylistSaves() {
  _fetchPlaylistSaves = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(playlistId, period) {
    var updated_time, q, resp;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          updated_time = formatPeriod(period);
          q = {
            fields: [{
              saveCount: 'COUNT(id)'
            }],
            filter: {
              collection_id: playlistId,
              updated_time: updated_time,
              saved: 1
            }
          };
          _context3.next = 4;
          return api('get', '/api/query/userCollections', q);
        case 4:
          resp = _context3.sent;
          return _context3.abrupt("return", resp.items[0].saveCount || 0);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchPlaylistSaves.apply(this, arguments);
}
function fetchPlaylistCompletionCount(_x5, _x6) {
  return _fetchPlaylistCompletionCount.apply(this, arguments);
}
function _fetchPlaylistCompletionCount() {
  _fetchPlaylistCompletionCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(playlistId, period) {
    var updated_time, q, resp;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          updated_time = formatPeriod(period);
          q = {
            fields: [{
              completionCount: 'COUNT(id)'
            }],
            filter: {
              collection_id: playlistId,
              updated_time: updated_time,
              completion_rate: 1
            }
          };
          _context4.next = 4;
          return api('get', '/api/query/userCollections', q);
        case 4:
          resp = _context4.sent;
          return _context4.abrupt("return", resp.items[0].completionCount || 0);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchPlaylistCompletionCount.apply(this, arguments);
}
function fetchPlaylistHistory(playlistId, period) {
  return api('get', "/api/playlists/".concat(playlistId, "/stats/"), {
    duration: period
  });
}
export var useFetchPlaylistAnalytics = function useFetchPlaylistAnalytics(_ref) {
  var playlistId = _ref.playlistId,
    period = _ref.period,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchPlaylistAnalytics() {
    return _fetchPlaylistAnalytics.apply(this, arguments);
  }
  function _fetchPlaylistAnalytics() {
    _fetchPlaylistAnalytics = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var promiseList, _yield$Promise$all, _yield$Promise$all2, playlistOpens, playlistSaves, playlistCompletions, playlistHistory, playlistComments, opensCount, savesCount, completionsCount, commentsCount, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            promiseList = [fetchPlaylistOpens(playlistId, period), fetchPlaylistSaves(playlistId, period), fetchPlaylistCompletionCount(playlistId, period), fetchPlaylistHistory(playlistId, period)];
            if (config.enableComments) {
              promiseList.push(fetchContentComments(playlistId, period));
            }
            _context.next = 4;
            return Promise.all(promiseList);
          case 4:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 5);
            playlistOpens = _yield$Promise$all2[0];
            playlistSaves = _yield$Promise$all2[1];
            playlistCompletions = _yield$Promise$all2[2];
            playlistHistory = _yield$Promise$all2[3];
            playlistComments = _yield$Promise$all2[4];
            opensCount = checkIsNumber(playlistOpens) ? playlistOpens : 0;
            savesCount = checkIsNumber(playlistSaves) ? playlistSaves : 0;
            completionsCount = checkIsNumber(playlistCompletions) ? playlistCompletions : 0;
            commentsCount = checkIsNumber(playlistComments) ? playlistComments : 0;
            data = [{
              title: i18n.t('stats_open', {
                count: opensCount
              }),
              value: opensCount
            }, {
              title: i18n.t('stats_save', {
                count: savesCount
              }),
              value: savesCount
            }, {
              title: i18n.t('stats_completed', {
                count: completionsCount
              }),
              value: completionsCount
            }];
            if (config.enableComments) {
              data.push({
                title: i18n.t('stats_comment', {
                  count: commentsCount
                }),
                value: commentsCount
              });
            }
            return _context.abrupt("return", {
              data: data,
              history: checkIsNumber(playlistHistory) ? [] : playlistHistory.history
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchPlaylistAnalytics.apply(this, arguments);
  }
  var _useQuery = useQuery(playlistQueryKeys.playlistAnalytics(playlistId, period), fetchPlaylistAnalytics, _objectSpread(_objectSpread({
      enabled: isAdmin()
    }, queryOptions), {}, {
      staleTime: 5 * 60 * 1000
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
};
export default useFetchPlaylistAnalytics;